import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import { Paper } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';
import AdImg from '../../../assets/images/LTOE_MobileAppBanner.webp';

const styles = (theme) => ({
    desktopWrapper: {
        display: 'flex',
        borderBottom: `1px solid ${COLORS.WHITE_LILAC}`,
        paddingLeft: '20px',
        marginTop: '32px',
        paddingBottom: '32px',
        flexDirection: 'column',
        textAlign: 'left',
    },
    header: {
        color: COLORS.ST_TROPAZ,
        fontWeight: '700',
        fontSize: '18px',
        margin: 0,
    },
    spanTitleFont: {
        fontWeight: '900',
        color: COLORS.RAVEN,
        fontSize: '12px',
        display: 'flex',
        textTransform: 'uppercase',
    },
    emptyStateWrapper: {
        display: 'flex',
    },
    innerCardEmptyWrapper: {
        margin: '10px 20px',
        display: 'flex',
        padding: '10px',
        borderRadius: '5px',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-around',
        border: `1px solid ${COLORS.WHITE_LILAC}`,
        [theme.breakpoints.down('sm')]: {
            margin: '10px 10px',
        },
    },
    dateFont: {
        fontWeight: '300',
        textTransform: 'uppercase',
    },
    addressWrapper: {
        paddingBottom: '16px',
    },
    addressFont: {
        fontWeight: '500',
        fontSize: '14px',
        color: COLORS.RAVEN,
    },
    emptyStateHeader: {
        textAlign: 'left',
        fontWeight: '700',
        letterSpacing: '0',
        fontSize: '20px',
        color: COLORS.RAVEN,
        opacity: '0.3',
    },
    presentDate: {
        display: 'flex',
        flexFlow: 'column',
    },
});

class AdCard extends Component {
    render() {
        const { classes, t } = this.props;
        return (
            <div>
                <a
                    href="https://www.locumtenens.com/ppc/mobile-app/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img src={AdImg} alt="Ad" style={{ maxWidth: '100%', height: 'auto' }} />
                </a>
            </div>
        );
    }
}

export default withTranslation()(withStyles(styles)(AdCard));
